import { render, staticRenderFns } from "./GameSkeleton.vue?vue&type=template&id=277624fe&scoped=true&"
import script from "./GameSkeleton.vue?vue&type=script&lang=js&"
export * from "./GameSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277624fe",
  null
  
)

export default component.exports